// LYTICK Haptics Utility
// Uses navigator.vibrate() for Android Chrome support
// Silent no-op on devices without vibration API

const SUPPORTED = typeof navigator !== 'undefined' && 'vibrate' in navigator

const patterns = {
  light: [10],
  selection: [15],
  success: [25, 50, 25],
  error: [50, 30, 50, 30, 80],
  heavy: [80],
}

function vibrate(pattern: number[]) {
  if (SUPPORTED) {
    navigator.vibrate(pattern)
  }
}

function stop() {
  if (SUPPORTED) {
    navigator.vibrate(0)
  }
}

const haptics = {
  light: () => vibrate(patterns.light),
  selection: () => vibrate(patterns.selection),
  success: () => vibrate(patterns.success),
  error: () => vibrate(patterns.error),
  heavy: () => vibrate(patterns.heavy),
  stop,
}

export default haptics
